import { ValidationError } from "sequelize"
import {
    QidDatapointCreate,
    QidModelFailureMode,
    QidModelFailureModeCreate,
    QidModelFailureModeSave,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    QidModelFailureModeValidation,
    LoadQidDatapoints,
    PrepareDatapoints,
    SaveQidDatapoint,
    UpdateQidDependingDevices,
    initQidDatapoint,
} from "client/store"


export const LoadQidModelFailureModeById = (failureModeId: number) => (
    GET(`/qidModelFailureMode/id/${failureModeId}`)
    .then((failureMode: QidModelFailureMode) => failureMode)
)

export const SaveQidModelFailureMode = (
    id: number,
    failureMode: QidModelFailureModeCreate,
    lang: LangType,
) => {
    const data: QidModelFailureModeSave = {
        id,
        failureMode,
    }
    return POST(
        "/qidModelFailureMode/save",
        JSON.stringify(data),
    ).then((res) => {
        const newFailureMode = res as QidModelFailureMode
        const error = res as ValidationError

        // add new rows to "qid_datapoint" table to alredy existing datapoints
        return LoadQidDatapoints({
            safetyFunctionId: failureMode.safetyFunctionId,
        }).then((datapoints) => {
            const datapointGroups = PrepareDatapoints(datapoints)
            const promiseArray: Promise<any>[] = []

            if (newFailureMode && newFailureMode.id) {
                datapointGroups.forEach((group) => {
                    group.datapoints.forEach((parentDatapoint) => {
                        const childDatapoint: QidDatapointCreate = {
                            ...initQidDatapoint,
                            datapointId: parentDatapoint.id,
                            productId: parentDatapoint.productId,
                            modelId: parentDatapoint.modelId,
                            safetyFunctionId: parentDatapoint.safetyFunctionId,
                            optionId: parentDatapoint.optionId,
                            failureModeId: newFailureMode.id,
                        }

                        promiseArray.push(
                            SaveQidDatapoint(null, childDatapoint),
                        )
                    })
                })
            }

            return Promise.all(promiseArray).then(() => ({
                newFailureModeId: newFailureMode.id || null,
                validation: <QidModelFailureModeValidation>validate(error, lang),
            }))
        })
    })
}

export const DeleteQidModelFailureMode = (failureModeId: number) => (
    LoadQidDatapoints({ failureModeId }).then((datapoints) => (
        DELETE(`/qidModelFailureMode/delete/${failureModeId}`)
        .then((removedRows: number) => {
            if (removedRows === 1) {
                // update SIL project devices
                const promiseArray: Promise<any>[] = []
                datapoints.forEach((datapoint) => {
                    promiseArray.push(
                        UpdateQidDependingDevices({
                            update: true,
                            qidProductId: datapoint.productId,
                            qidModelId: datapoint.modelId,
                            qidSafetyFunctionId: datapoint.safetyFunctionId,
                            qidOptionId: datapoint.optionId,
                            qidDatapointId: datapoint.datapointId, // parent datapoint
                        }),
                        UpdateQidDependingDevices({
                            update: true,
                            qidProductId: datapoint.productId,
                            qidModelId: datapoint.modelId,
                            qidSafetyFunctionId: datapoint.safetyFunctionId,
                            qidOptionId: datapoint.optionId,
                            qidDatapointId: null,
                        }),
                        UpdateQidDependingDevices({
                            update: true,
                            qidProductId: datapoint.productId,
                            qidModelId: datapoint.modelId,
                            qidSafetyFunctionId: datapoint.safetyFunctionId,
                            qidOptionId: null,
                        }),
                        UpdateQidDependingDevices({
                            update: true,
                            qidProductId: datapoint.productId,
                            qidModelId: datapoint.modelId,
                            qidSafetyFunctionId: null,
                        }),
                        UpdateQidDependingDevices({
                            update: true,
                            qidProductId: datapoint.productId,
                            qidModelId: null,
                        }),
                    )
                })

                return Promise.all(promiseArray).then(() => removedRows)
            }
            return removedRows
        })
    ))
)
